export default "__VITE_ASSET__D7Pu973M__"